import { Button, Modal, notification } from 'antd'
import React, { useState } from 'react'

import { deleteTrade } from '../../../api/delete-trade'
import { formatCurrency } from '../../../formatters'
import { messages } from '../messages'
import { TradeTableItem } from '../models'

const buildDeleteTradeMessage = (tradeToDelete: TradeTableItem) =>
  `Are you sure that you want to delete this trade?\n
  - Instrument: ${tradeToDelete.instrumentCode}\n
  - Principal: ${formatCurrency({ value: tradeToDelete.principal, notation: 'standard', style: 'currency' })}\n
  - ID: ${tradeToDelete.id}\n
  It cannot be reverted`

interface DeleteTradeProps {
  trade: TradeTableItem
  domain: string
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const DeleteTradeModal = ({ trade, domain, isVisible, onClose, onSuccess }: DeleteTradeProps) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const onDelete = async (tradeId: number, domain: string) => {
    setIsDeleting(true)

    try {
      await deleteTrade({ tradeId, domain })
      onSuccess()
      notification.success({ message: messages.common.success, description: messages.trade.delete.success })
    } catch (error) {
      notification.error({ message: messages.common.error, description: error.error_message })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      title="Delete trade"
      onCancel={onClose}
      open={isVisible}
      className="delete-modal-message"
      footer={[
        <div className="footer">
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => onDelete(trade.id, domain)}
            disabled={isDeleting}
            loading={isDeleting}
            type="primary"
            danger
          >
            Delete Trade
          </Button>
        </div>,
      ]}
    >
      {trade && buildDeleteTradeMessage(trade)}
    </Modal>
  )
}
